// Components
import Home from '../home';


export const routes = [
  {
    path: '/',
    component: Home,
    exact: true
  }
];
